// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".images[data-v-747fb05a]{cursor:pointer;display:flex}.images img[data-v-747fb05a]{max-width:300px;width:100%;cursor:pointer}", ""]);
// Exports
module.exports = exports;
